<template>
	<div @drop.prevent="dropFile($event)" @dragover.prevent @dragenter.prevent class="column is-full is-flex is-justify-content-center is-align-items-center is-flex-direction-column" style="border: 1px solid #EEEEEE; border-radius: 8px; background-color:#FBFBFB">
		<img src="/images/icons/excelupload.svg" alt="" style="min-width: 40px">
		<div class="is-flex is-justify-content-center is-align-items-center py-4">
			<div class="is-size-4 has-text-weight-bold pr-4">{{ preButtonText }}</div>
			<button @click="btnClick" type="button" :class="classes" style="margin-top: 0.5rem !important;">
				<i class="fa-solid fa-upload px-3"></i>
				{{ buttonText }}
			</button>
				<input type="file" :name="name" :ref="name" @change="uploadFile" class="is-hidden" tabindex="-1" :accept="fileFormats">
				<div class="is-size-7 is-marged-bottom">{{notice}}</div>
		</div>
		<div>{{ formatText + removeDotsAndUppercase( fileFormats )}}</div>
	</div>
</template>

<script>
export default {
	props: {
		fileFormats: String,
		fileFormatError: String,
		multipleFilesError: String,
		name: String,
		classes: String,
		preButtonText: String,
		buttonText: String,
		formatText: String,
		notice: String,
	},
	data: function ()
	{
		return {
			regex: new RegExp('(' + this.fileFormats
					.replaceAll('.', '\\.')
					.replaceAll(',', '|') + ')$', 'i')
		}
	},
	methods: {
		btnClick: function ()
		{
			$('input[name="' + this.name + '"]').val(null);
			$('input[name="' + this.name + '"]').click();
		},
		dropFile: function (event)
		{
			$('.drop-area').removeClass('dragging');
			cleanFlashAlert();
			if (event.dataTransfer.files.length !== 1)
			{
				addFlashAlert('danger', this.multipleFilesError);
				return;
			}
			if (!this.regex.exec(event.dataTransfer.files[0].name))
			{
				addFlashAlert('danger', this.fileFormatError);
				return;
			}
			this.$refs[this.name].files = event.dataTransfer.files;
			this.uploadFile();
		},
		uploadFile: function ()
		{
			this.$emit('change',this.$refs[this.name]);
		},
		removeDotsAndUppercase: function(str)
		{
			return str.replace(/\./g, ' ').toUpperCase();
		}
	},
	mounted() {
		$('.drop-area').on("dragover", (event) => {
			$('.drop-area').addClass('dragging');
		});
		$('.drop-area').on("dragend", (event) => {
			$('.drop-area').removeClass('dragging');
		});
		$('.drop-area').on("dragleave", (event) => {
			$('.drop-area').removeClass('dragging');
		});
	},
}
</script>
